import styled from 'styled-components';

import { PageContentContainer } from '~src/styles/containers.sc';

export const PageContentContainerS = styled(PageContentContainer)`
  padding-top: 30px;
`;

export const OptionAddContainer = styled.div`
  margin-top: 60px;
`;

export const AttrOptionsContainer = styled.div`
  margin-top: 30px;
`;
